// ** React Imports
import { forwardRef } from 'react'

// ** Third Party Imports
import * as Form from '@radix-ui/react-form'

// ** Styled Components
import { FormLabelStyled, TextAreaStyled } from './styles'

interface IProps {
	name: string
	label?: string
	value?: string | number
	isError?: boolean
	minRows?: number
	maxRows?: number
	onChange?: (
		e: React.ChangeEvent<HTMLTextAreaElement> | string | undefined
	) => void
	onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void
	isSuccess?: boolean
	fullWidth?: boolean
	className?: string
	endIcon?: JSX.Element
	startIcon?: JSX.Element
	placeholder?: string,
	transparentInput?: boolean,
}

export const TextAreaInputField = forwardRef<HTMLTextAreaElement, IProps>(
	(
		{
			name,
			label,
			value,
			isError = false,
			minRows,
			maxRows,
			onChange,
			onKeyDown,
			isSuccess = false,
			fullWidth = false,
			endIcon,
			startIcon,
			className,
			placeholder,
			transparentInput = false
		},
		ref
	) => {
		const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
			if (e.key === 'Enter') {
				if (e.shiftKey) {
					onKeyDown?.(e)
					return
				}

				e.preventDefault()
				onKeyDown?.(e)
				const form = e.currentTarget.form
				form?.requestSubmit()
				return
			}

			onKeyDown?.(e)
		}

		return (
			<>
				<Form.Control asChild>
					<TextAreaStyled
						ref={ref}
						name={name}
						value={value}
						minRows={minRows}
						maxRows={maxRows}
						$isError={isError}
						onChange={onChange}
						onKeyDown={handleKeyDown}
						$isSuccess={isSuccess}
						$fullWidth={fullWidth}
						className={className}
						$startIcon={startIcon}
						placeholder={placeholder ?? ' '}
						$transparentInput={transparentInput}
					/>
				</Form.Control>

				{/* Conditionally render input field start icon */}
				{startIcon !== undefined && startIcon}

				{/* Conditionally render input label */}
				{label !== undefined && (
					<FormLabelStyled $startIcon={startIcon}>{label}</FormLabelStyled>
				)}

				{/* Conditionally render input field end icon */}
				{endIcon !== undefined && endIcon}
			</>
		)
	}
)
